import {createFileRoute} from '@tanstack/react-router';
import {AuthenticationPage} from 'pages';

export const Route = createFileRoute('/auth')({
  component: AuthenticationPage,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      code: search.code as string | undefined,
      state: search.state as string | undefined,
      codeVerifier: search.codeVerifier as string | undefined,
      error: search.error as string | undefined,
      error_description: search.error_description as string | undefined,
    };
  },
});
